import PropTypes from 'prop-types';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useSelector } from 'react-redux';

import { paginationTotalRenderer, sizePerPageRenderer } from '../../../utils/tableHelper';
import styles from './InventoryHistoryLogModal.module.scss';

import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import ModalWindow from '../../common/Modal';
import { CymbioSpinner } from '../../common/Spinner';
import {
  inventoryHistoryColumns,
  inventoryHistoryColumnsWithoutInitiator,
} from './columns/inventory-history-table-columns';
import { inventoryHistoryLogInitiatorFlag } from '../../../constants/featureFlag';

function InventoryHistoryLogModal(props) {
  const { isLoading } = useSelector((state) => state.historyLog);
  const { variant, offset, perPage, onClose, open = false } = props;
  const isInventoryHistoryInitiatorEnabled = useFeatureFlag(inventoryHistoryLogInitiatorFlag, false, true);

  const onPageChange = (page) => props.setPage((page - 1) * perPage);

  const pagination = paginationFactory({
    page: offset / perPage + 1,
    sizePerPage: perPage,
    sizePerPageList: [10],
    onPageChange: onPageChange,
    totalSize: props.count,
    showTotal: true,
    sizePerPageRenderer,
    paginationTotalRenderer,
  });

  const noDataIndication = () => `There is no data to display`;

  const columns = isInventoryHistoryInitiatorEnabled
    ? inventoryHistoryColumns
    : inventoryHistoryColumnsWithoutInitiator;

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <div className={styles.header}>
        <h3>
          Inventory History Log for: <strong>{variant.title}</strong>
        </h3>

        {isLoading && (
          <div>
            <CymbioSpinner />
          </div>
        )}

        <ul>
          <li>
            <label>SKU:</label>
            <span>{variant.sku}</span>
          </li>
          {variant.upc && (
            <li>
              <label>UPC:</label>
              <span>{variant.upc}</span>
            </li>
          )}
          {variant.ean && (
            <li>
              <label>EAN:</label>
              <span>{variant.ean}</span>
            </li>
          )}
        </ul>
      </div>

      {!isLoading && (
        <BootstrapTable
          data={props.data}
          columns={columns}
          keyField="id"
          striped
          hover
          bordered={false}
          pagination={pagination}
          noDataIndication={noDataIndication}
          remote={{
            pagination: true,
          }}
        ></BootstrapTable>
      )}
    </ModalWindow>
  );
}

export default InventoryHistoryLogModal;

InventoryHistoryLogModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
